import { render, staticRenderFns } from "./sifremiUnuttum.vue?vue&type=template&id=237b2c03"
import script from "./sifremiUnuttum.vue?vue&type=script&lang=js"
export * from "./sifremiUnuttum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports